import { useContext } from 'react';
import DraggableChatContext from '../context/DraggableChat';

const useDraggableChat = () => useContext(DraggableChatContext);

export default useDraggableChat;